import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import Card from "../../../components/Globo/Card/Card";
import { pluralize } from "../../../utils/a11y/ptBr";

const FORMAT_PLACEHOLDER = "-";

// full description read by screen readers for the card's whole-card action, since its
// clickable overlay has no visible text content of its own
const buildCardAriaLabel = ({ title, isNew, parecerCount, format }) => {
  const count = typeof parecerCount === "number" ? parecerCount : 0;

  return [
    title,
    isNew && "Novo",
    `${count} ${pluralize(count, "parecer", "pareceres")}`,
    `Formato ${format || "não informado"}`,
  ]
    .filter(Boolean)
    .join(", ");
};

const CultureHubCard = ({
  title,
  isNew,
  parecerCount,
  format,
  onClick,
  ...props
}) => (
  <Card
    onClick={onClick}
    ariaLabel={buildCardAriaLabel({ title, isNew, parecerCount, format })}
    hideContentFromAT
    maxHeight="112px"
    {...props}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 1,
      }}
    >
      <Typography
        variant="subtitle1"
        component="h3"
        noWrap
        sx={{
          fontFamily: "inherit",
          fontSize: "16px",
          fontWeight: 600,
          color: "#252527",
          minWidth: 0,
          pr: "16px", // to avoid text overlapping with the right-side icons
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexShrink: 0,
        }}
      >
        {isNew && (
          <Chip
            label="Novo"
            size="small"
            sx={{
              backgroundColor: "#ffe1e6",
              color: "#e0294b",
              fontFamily: "inherit",
              fontWeight: 700,
              height: 24,
            }}
          />
        )}
      </Box>
    </Box>

    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontFamily: "inherit",
          color: "#939598",
          fontSize: "14px",
          fontWeight: 500,
          pr: "8px",
        }}
      >
        {format || FORMAT_PLACEHOLDER}
      </Typography>
    </Box>
  </Card>
);

export default CultureHubCard;
